import React from "react";
import UI from "@mile-meeting/mile-ui";
import styled from "@emotion/styled";

const GoogleSyncFeature = ({ onHandleSync }: { onHandleSync: () => void }) => {
  return (
    <ContentContainer>
      <TitleContainer>
        <UI.Typography type="body01 normal" fontStyle="bold">
          GWS 멤버 정보 연동
        </UI.Typography>
        <UI.Typography type="body02 normal" color="var(--alias-color-label-alternative)">
          Google Workspace 내 도메인 혹은 조직 단위의 멤버 정보 연동, 동기화가 가능합니다.
        </UI.Typography>
      </TitleContainer>
      <UI.Button
        title="연동하기"
        prefixIcon="link"
        size="small"
        primary={false}
        showPrefixIcon
        onClick={onHandleSync}
      />
    </ContentContainer>
  );
};

export default React.memo(GoogleSyncFeature);

export const ContentContainer = styled.div<{ underline?: boolean }>`
  display: flex;
  padding: 20px 28px 20px 40px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-bottom: ${({ underline }) => (underline ? "2px solid var(--alias-color-line-alternative)" : "none")};
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
`;
